var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConteudoPageForm',{attrs:{"apiBasePath":"/admin/site-postagens","entityName":"Postagem","breadcrumb":"Marketing / Postagens","listRouteName":"postagens","iaEndpoint":"/admin/site-postagens/gerar-conteudo-ia","iaPlaceholder":"Ex: 5 dicas para escolher a tinta ideal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }